<div class="text-center">
  <h2 class="font-weight-bold text-primary">Sign In</h2>
  <p class="text-muted">Enter your username and password</p>
</div>
<!--begin::Form-->
<form
  #loginForm="ngForm"
  (ngSubmit)="onSubmit(loginForm)"
  class="form"
  novalidate="novalidate"
>
  <div class="form-group py-3 m-0">
    <mat-form-field class="example-full-width">
      <input
        matInput
        type="text"
        placeholder="Username"
        ngModel
        name="username"
        required
      />
    </mat-form-field>
  </div>
  <div class="form-group py-3 m-0">
    <mat-form-field class="example-full-width">
      <input
        matInput
        [type]="pwdhide ? 'password' : 'text'"
        autocomplete="off"
        placeholder="Password"
        ngModel
        name="password"
        required
      />
      <a
        mat-icon-button
        matSuffix
        (click)="pwdhide = !pwdhide"
        [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="pwdhide"
      >
        <mat-icon>{{ pwdhide ? 'visibility_off' : 'visibility' }}</mat-icon>
      </a>
    </mat-form-field>
  </div>
  <div *ngIf="error" class="text-secondary">{{ error }}</div>
  <div class="d-flex flex-wrap justify-content-between align-items-center">
    <ng-container *ngIf="forgotpasswordlink">
      <a
        (click)="forgotpassword()"
        href="javascript:;"
        id="kt_login_forgot"
        class="text-primary text-hover-primary"
        >Forgot/Set Password ?</a
      >
    </ng-container>
    <button
      [disabled]="!loginForm.valid"
      type="submit"
      id="kt_login_signin_submit"
      class="btn btn-primary font-weight-bold px-9 py-4 my-3"
    >
      Sign In
    </button>
  </div>
  <div
    *ngIf="signupLink"
    class="form-group d-flex flex-wrap justify-content-between align-items-center"
  >
    <a
      (click)="signup()"
      id="kt_login_signin_submit"
      class="btn text-primary border-dark btn-block font-weight-bold px-9 py-4 my-3"
    >
      Create an Account
    </a>
  </div>
</form>
<!--end::Form-->
